import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { CyTestDirective } from '@portal/directive';
import { ReactiveFormsModule } from '@angular/forms';
import { PortalFieldTypeConfig } from '@portal/form/data-access';

@Component({
  selector: 'portal-form-checkbox-boolean',
  standalone: true,
  imports: [FormlyModule, MatCheckboxModule, CyTestDirective, ReactiveFormsModule],
  template: `
    <mat-checkbox
      [id]="id"
      class="field-checkbox"
      [formControl]="formControl"
      [portalCyTest]="field.key"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [disabled]="disabled"
      [color]="defaultOptions.props.color"
      [labelPosition]="defaultOptions.props.labelPosition"
      >{{ props.labelCheckbox }}
    </mat-checkbox>
  `,
  styles: [
    `
      :host {
        @apply flex flex-col items-start gap-2 mt-2;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxBooleanComponent extends FieldType<PortalFieldTypeConfig> {
  override defaultOptions = { props: { color: 'primary' as const, labelPosition: 'after' as const } };

  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [{ name: 'checkbox-boolean', component: CheckboxBooleanComponent, wrappers: ['form-field'] }],
    }),
  ],
})
export class FormCheckboxBooleanModule {}
